import React from 'react';
// import Promociones from "../../paquetes-detalle/panel-promocion/panel-promocion";
import Financiacion from '../../../commons/ver-financiacion';

const PagoEnAgencia = (props) => (

  <div className='panel panel-default custom bordeado '>
    <div className='panel-body'>
      <Financiacion
        id={props.paquete.idProducto}
        uniqueId={1}
        appId={props.paquete.applicationId}
        price={props.precio}
        customText={(
          <>
            <i className='fa fa-credit-card' />
            {' '}
            <span style={{ textDecoration: 'underline' }}> Ver opciones de pago</span>
          </>
        )}
      />
    </div>
  </div>

);

export default PagoEnAgencia;
